global.jquery = global.jQuery = global.$ = require('jquery');

window.Popper = require('popper.js');

import 'bootstrap';
import 'jquery-validation';
import IMask from 'imask';

import './pages/catalog/category.js';
import './pages/catalog/product.js';
import './pages/shop/cart.js';
import './pages/shop/payment.js';
import './pages/user/registration';
import './pages/user/login';
import './pages/user/password-restore';
import './pages/user/password-reset';
import './pages/user/profile';

$('.carousel').carousel({
    interval: 0
});

$('.navbar-toggler').click(function () {
    $(this).toggleClass('active');
});

$('#catalogNaxToggler').click(function () {
    $('.catalog__nav').slideToggle();
});

$(function () {

    /*MENU*/

    $('.menu-main a').hover(function () {
        $('.menu-main a').removeClass('active');
        $(this).addClass('active');
        var attr = $(this).attr("data-link");
        $('.menu-right-item').removeClass('active');
        $(attr).addClass('active');

    });

    $('.mob').click(function () {
        if ($(window).width() < 768) {
            $('.drop-menu').removeClass('open');
            $(this).find('.drop-menu').addClass('open');
        }
    });

});

let phoneInput = document.querySelector('.phonetext');
if (phoneInput) {
    IMask(phoneInput, {
        mask: '{+7} (#00) 000 0000',
        definitions: {
            '#': /[012345679]/
        },
        lazy: false,
        placeholderChar: ' '
    });
}

$(document).ready(function () {

    $('[data-toggle="tooltip"]').tooltip();

    $("._ajax_cart_link_header_wrapper").sticky({});
});


/**
 * Yandex map lazy loading
 */
document.addEventListener('DOMContentLoaded', function() {
    /** init gtm after 10 seconds - this could be adjusted */
    setTimeout(initYandexMap, 10000);
});
document.addEventListener('scroll', initYandexMapOnEvent);
document.addEventListener('mousemove', initYandexMapOnEvent);
document.addEventListener('touchstart', initYandexMapOnEvent);

function initYandexMapOnEvent (e) {
    initYandexMap();
    // remove the event listener that got triggered
    e.currentTarget.removeEventListener(e.type, initYandexMapOnEvent);
}

function initYandexMap () {
    if (window.yandexMapDidInit) {
        return false;
    }
    window.yandexMapDidInit = true;

    const elMap = document.getElementById("YandexMap");
    if (!elMap) {
        return false;
    }
    if (!window.shopAddresses || !window.shopAddresses.length) {
        return false;
    }

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = 'https://api-maps.yandex.ru/2.1/?lang=ru_RU';
    script.onload = function () {
        ymaps.ready(function () {
            const map = new ymaps.Map("YandexMap", {
                center: [55.354968, 86.087314],
                zoom: 11,
                controls: ['zoomControl', 'fullscreenControl']
            });
            map.behaviors.disable('scrollZoom');

            const clusterer = new ymaps.Clusterer({
                preset: 'islands#invertedVioletClusterIcons',
                groupByCoordinates: false,
                clusterDisableClickZoom: true
            });
            const arGeoObjects = [];

            const promises = window.shopAddresses.map(function (item) {
                return ymaps.geocode(item.query, { results: 1 }).then(function (res) {
                    const firstGeoObject = res.geoObjects.get(0);
                    if (!firstGeoObject) {
                        return null;
                    }
                    const coords = firstGeoObject.geometry.getCoordinates();
                    const placemark = new ymaps.Placemark(coords, {
                        hintContent: item.address,
                        balloonContent: item.address
                    }, {
                        preset: 'islands#greenDotIcon'
                    });
                    arGeoObjects.push(placemark);
                    return placemark;
                });
            });

            Promise.all(promises).then(function () {
                if (arGeoObjects.length) {
                    clusterer.add(arGeoObjects);
                    map.geoObjects.add(clusterer);
                    map.setBounds(clusterer.getBounds(), {
                        checkZoomRange: true,
                        zoomMargin: 20
                    });
                }
            });
        });
    };
    document.head.appendChild(script);
}


/**
 * Jivosite lazy loading
 */
// document.addEventListener('DOMContentLoaded', function() {
//     /** init gtm after 10 seconds - this could be adjusted */
//     setTimeout(initJivoSite, 8000);
// });
// document.addEventListener('scroll', initJivoSiteOnEvent);
// document.addEventListener('mousemove', initJivoSiteOnEvent);
// document.addEventListener('touchstart', initJivoSiteOnEvent);

// function initJivoSiteOnEvent (e) {
//     initJivoSite();
//     // remove the event listener that got triggered
//     e.currentTarget.removeEventListener(e.type, initJivoSiteOnEvent);
// }

// function initJivoSite () {
//     if (window.jivoSiteDidInit) {
//         return false;
//     }
//     window.jivoSiteDidInit = true; // flag to ensure script does not get added to DOM more than once.
//     const script = document.createElement('script');
//     script.type = 'text/javascript';
//     script.async = true;
//     script.src = '//code-ya.jivosite.com/widget/x4aTQUI2Ld';
//
//     document.getElementById("YandexMap").appendChild(script);
// }
